var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolCodetobrd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.533 392.533",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.267,110.287c6.012,0,10.925-4.848,10.925-10.925v-9.956c0-6.012-4.848-10.925-10.925-10.925 s-10.925,4.848-10.925,10.925v9.956C185.341,105.438,190.255,110.287,196.267,110.287z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M129.293,68.655L129.293,68.655c0,6.012-4.848,10.925-10.925,10.925H32.711 c-6.012,0-10.925,4.848-10.925,10.925v221.543c0,6.012,4.848,10.925,10.925,10.925h327.111c6.012,0,10.925-4.849,10.925-10.925 V90.44c0-6.012-4.848-10.925-10.925-10.925h-89.535c-6.012,0-10.925-4.848-10.925-10.925l0,0H129.293V68.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M348.897,101.301v199.758H43.572v-14.739h9.374c6.012,0,10.861-4.848,10.861-10.861 s-4.848-10.925-10.861-10.925h-9.374v-19.265h31.547c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925H43.572 V101.236h101.042v34.004l-38.077,22.044c-3.426,1.939-5.495,5.56-5.495,9.438V243.2c0,3.879,2.069,7.499,5.495,9.438 c1.681,0.97,6.335,2.844,10.925,0l41.051-23.661h1.939l26.246,48.614c1.939,3.556,5.56,5.689,9.568,5.689s7.628-2.198,9.568-5.689 l26.246-48.614h1.939l41.051,23.661c4.461,2.78,9.18,0.97,10.925,0c3.426-1.939,5.495-5.56,5.495-9.438v-76.412 c0-3.943-2.069-7.499-5.495-9.438l-38.077-22.044v-34.004C247.919,101.301,348.897,101.301,348.897,101.301z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#56ACE0"
    },
    points: "166.529,86.238 166.529,207.257 226.004,207.257 226.004,86.238 196.267,33.164 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "247.855,211.782 269.576,224.388 269.576,172.994 247.855,160.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "144.679,160.517 122.958,172.994 122.958,224.388 144.679,211.782  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "196.267,249.535 207.386,229.042 185.147,229.042  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#56ACE0"
    },
    points: "138.473,344.63 120.695,370.683 271.838,370.683 254.061,344.63 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M285.996,157.35l-38.077-22.044V83.394c0-1.875-0.453-3.685-1.422-5.301L205.77,5.56 C203.83,2.133,200.21,0,196.267,0s-7.564,2.133-9.503,5.56l-40.727,72.533c-0.905,1.616-1.422,3.491-1.422,5.301v51.911 l-38.077,22.044c-3.426,1.939-5.495,5.56-5.495,9.438v76.477c0,3.879,2.069,7.499,5.495,9.438c1.681,1.034,6.335,2.844,10.925,0 l41.05-23.661h1.939l26.246,48.614c1.939,3.556,5.56,5.689,9.568,5.689c4.008,0,7.628-2.133,9.568-5.689l26.246-48.614h1.939 l41.05,23.661c4.461,2.78,9.18,1.034,10.925,0c3.426-1.939,5.495-5.56,5.495-9.438v-76.477 C291.491,162.844,289.358,159.289,285.996,157.35z M269.576,224.388l-21.786-12.606v-51.329l21.786,12.606V224.388z  M226.004,207.257H166.4V86.238l29.802-53.075l29.737,53.139v120.954H226.004z M122.958,172.994l21.786-12.606v51.329 l-21.786,12.606V172.994z M196.267,249.535l-11.119-20.493h22.174L196.267,249.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M359.822,57.665h-89.535c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.99,10.925,10.99 h89.535c6.012,0,10.925,4.848,10.925,10.925v221.543c0,6.012-4.848,10.925-10.925,10.925H32.711 c-6.012,0-10.925-4.849-10.925-10.925V90.44c0-6.012,4.848-10.925,10.925-10.925h85.721c6.012,0,10.925-4.848,10.925-10.925 c0-6.012-4.848-10.925-10.925-10.925H32.711C14.675,57.6,0,72.275,0,90.376v221.543c0,18.036,14.675,32.711,32.711,32.711h79.386 l-21.01,30.772c-2.327,3.297-2.521,7.628-0.646,11.313c1.875,3.556,5.56,5.818,9.632,5.818H292.59h0.065 c6.012,0,10.925-4.849,10.925-10.925c0-2.78-1.099-5.301-2.78-7.24l-20.234-29.673h79.257c18.036,0,32.711-14.675,32.711-32.711 V90.44C392.533,72.339,377.859,57.665,359.822,57.665z M120.695,370.683l17.778-25.988h115.523l17.778,25.988H120.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.267,110.287c-6.012,0-10.925-4.848-10.925-10.925v-9.956c0-6.012,4.848-10.925,10.925-10.925 c6.012,0,10.925,4.848,10.925,10.925v9.956C207.192,105.438,202.279,110.287,196.267,110.287z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolCodetobrd);
export default __webpack_public_path__ + "static/media/tool_codetobrd.1154e1edae95e71441a9de72a56199df.svg";
export { ForwardRef as ReactComponent };